import { Component } from "@angular/core";

@Component({
  selector: "app-default-content",
  templateUrl: "default-content.component.html",
})
export class DefaultContentComponent {}
